import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { EffectsModule } from "@ngrx/effects";
import { StoreModule } from "@ngrx/store";
import { AccountStoreModule } from "./account-store";
import { AgencyStoreModule } from "./agency-store";
import { ClaimStoreModule } from "./claim-store";
import { PolicyStoreModule } from "./policy-store";
import { UserStoreModule } from "./user-store/user-store.module";

@NgModule({
  declarations: [],
  imports: [
    CommonModule,
    AccountStoreModule,
    PolicyStoreModule,
    ClaimStoreModule,
    AgencyStoreModule,
  UserStoreModule,
    StoreModule.forRoot({}),
    EffectsModule.forRoot([]),
  ],
})
export class RootStoreModule {}
